import axios from "axios";
import {CONST} from "../config/CONST";

const isSessionStorageSupported = typeof(Storage) !== "undefined";
const sessionStorageKey = 'navigation';

function saveToSessionStorage(menuItems) {
    if(isSessionStorageSupported) {
        sessionStorage.setItem(sessionStorageKey, JSON.stringify(menuItems));
    }
}

function getFromSessionStorage() {
    if(isSessionStorageSupported) {
        const sessionStorageItems = sessionStorage.getItem(sessionStorageKey);
        if(sessionStorageKey) {
            return JSON.parse(sessionStorageItems);
        }
    }
    return false;
}

export async function asyncGetDynamicNavigation()  {

    const navigation = {};

    // get navigation from cache
    const sessionStorageSavedNavigation = getFromSessionStorage();
    if(sessionStorageSavedNavigation) {
        return sessionStorageSavedNavigation;
    }

    // load fundstore menu (fundstore servlet)
    await axios({
        method: 'get',
        url: CONST.dynamicHeader.servletUrl
    }).then((response) => {
        if(response && response.data) {
            navigation.header = response.data.header;
            navigation.footer = response.data.footer;
        }
        else {
            console.warn('No response.data found (FUNDSTORE servelet)');
        }
    }).catch(error => {
        console.warn(error);
    });


    // load WordPress menu (wordpress API)
    await axios({
        method: 'get',
        url: CONST.dynamicHeader.wordpressMenuEndpointUrl
    }).then((response) => {
        const wpMenu = [];
        if(response && response.data && response.data.length) {
            response.data.forEach((wpMenuItem) => {
                // build "fundstore style" array items
                wpMenu.push({
                    CODICE: wpMenuItem.ID,
                    DESCR: wpMenuItem.post_title,
                    URL: wpMenuItem.url
                });
            });
            navigation.header.forEach((navItem,i) => {
                // replace fundstore menu with wordpress menu
                if(navItem.CODICE === CONST.dynamicHeader.mainSiteBlogPageCode) {
                    navigation.header[i].FOGLIE = wpMenu;
                }
            });
        }
        else {
            console.warn('No response.data found (WP)');
        }
    }).catch(error => {
        console.warn(error);
    });


    // cache navigation in session storage
    saveToSessionStorage(navigation);


    // return navigation
    return navigation;

}